export function normalizeIsraeliPhoneNumber(value?: string | null): string {
  const raw = (value || '').trim();
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';
  if (raw.startsWith('+')) return `+${digits}`;
  if (digits.startsWith('00')) return `+${digits.slice(2)}`;
  if (digits.startsWith('0')) return `+972${digits.slice(1)}`;
  return `+${digits}`;
}

export function normalizePhoneForWhatsAppLink(value?: string | null): string {
  return normalizeIsraeliPhoneNumber(value).replace(/^\+/, '');
}

export function localIsraeliPhoneNumber(value?: string | null): string {
  const normalized = normalizeIsraeliPhoneNumber(value);
  if (!normalized.startsWith('+972')) return '';
  return `0${normalized.slice(4)}`;
}
